// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4064":"db9b8348","5807":"4ac1c0e4","8986":"4ac1c0e4"}[chunkId] + ".chunk.css";
};